module.exports = __webpack_public_path__ + "static2023-4-17/img/close.0768302b.jpg";